import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useDeleteCandidateNote(candidateId) {
  const api = useAxios();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (noteId) => {
      return api.delete(`/candidate/${candidateId}/notes/${noteId}`);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["candidateNotes", candidateId] });
    },
  });
}
